import Home from './Home';

function App() {
  return (
    <div id="root">
      <Home />
    </div>
  );
}

export default App;